import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender, generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
import { IconVariations } from '../useIconVariation';

const draw16px =
  'M7.914 11a.277.277 0 0 1 .09.01.22.22 0 0 1 .08-.01Zm.04 3.74a.06.06 0 0 1-.04.01.772.772 0 0 1-.15-.02.592.592 0 0 0 .19.008Zm3.26-10.18H10.5V2A.75.75 0 1 0 9 2v2.56H7V2a.75.75 0 1 0-1.5 0v2.56h-.72a1.387 1.387 0 0 0-1.39 1.39v1.94a4.609 4.609 0 0 0 3.11 4.36v1a1.472 1.472 0 0 0 1.12 1.44.213.213 0 0 0 .12.03.035.035 0 0 0 .02.01.592.592 0 0 0 .19.01H8a.09.09 0 0 0 .05.01 1.1 1.1 0 0 0 .18-.02h.02a1.513 1.513 0 0 0 1.25-1.48v-1.01a4.611 4.611 0 0 0 3.1-4.35V5.948a1.387 1.387 0 0 0-1.386-1.39Zm-.11 3.33A3.115 3.115 0 0 1 8.084 11a.22.22 0 0 0-.08.01.277.277 0 0 0-.09-.01H8a3.113 3.113 0 0 1-3.11-3.11V6.058h6.21ZM8.084 11h-.17a.277.277 0 0 1 .09.01.22.22 0 0 1 .08-.01Zm-.11 3.74c.01.01.01.01.03.01h.05a.09.09 0 0 1-.05-.01Z';
const draw24px =
  'M17,7.246h-.25V3.9a1.75,1.75,0,1,0-3.5,0v3.35h-2.5V3.9a1.75,1.75,0,1,0-3.5,0v3.35H7A1.758,1.758,0,0,0,5.247,9v3.02a6.77,6.77,0,0,0,4.71,6.44v3.06a.75.75,0,0,0,1.5,0v-2.78a4.965,4.965,0,0,0,1.09,0v2.78a.75.75,0,0,0,1.5,0v-3.07a6.761,6.761,0,0,0,4.7-6.43V9A1.752,1.752,0,0,0,17,7.246ZM14.747,3.9a.251.251,0,0,1,.5,0v3.35h-.5Zm-6,0a.251.251,0,0,1,.5,0v3.35h-.5Zm8.5,8.12a5.25,5.25,0,0,1-10.5,0V9A.261.261,0,0,1,7,8.746H17a.254.254,0,0,1,.25.25Z';

const icons: IconVariations = {
  _16: { d: draw16px, viewBox: VIEWBOXES._16 },
  _24: { d: draw24px, viewBox: VIEWBOXES._24 },
};

const PlugIcon = forwardRef<SVGSVGElement, ComponentProps<typeof Icon>>(
  generateRenderedIcon(icons, 'plug'),
) as IconWithRender;

PlugIcon.displayName = 'PlugIcon';
PlugIcon.propTypes = Icon.propTypes;
PlugIcon.renderIcon = (props) => <PlugIcon {...props} />;
export default PlugIcon;
